<template>
  <!-- 头部导航 -->
  <div class="page_head_box">
    <div class="page_con_center">
      <div class="logo_box">
        <img src="@/assets/image/logo_top.png" class="logo" />
      </div>
      <div class="nav_box">
        <div
          class="nav_item"
          v-for="(v, k) in navList"
          :key="k"
          :class="nowActive == v.name || showHover == v.name ? 'this' : ''"
          @click="navClickHandler(v)"
        >
          <el-popover
            v-if="v.name == 'ProductCase'"
            placement="bottom"
            trigger="hover"
            :visible-arrow="false"
            popper-class="nav_item_menu"
            v-model="showPopover"
            @show="showHover = v.name"
            @hide="showHover = null"
            :popper-options="{
              boundariesElement: 'body',
              gpuAcceleration: false,
            }"
          >
            <span slot="reference">{{ v.label }}</span>
            <caseDropMenuVue @clickHandler="handlerClicker"></caseDropMenuVue>
          </el-popover>
          <span v-else>{{ v.label }}</span>
        </div>
      </div>
    </div>

    <!-- 业务咨询弹框 -->
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="515px"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      custom-class="dialog_style dialog_no_header dialog_operation"
    >
      <operationConsultDialog
        v-if="dialogVisible"
        @closeDialog="closeDialogHandler"
      ></operationConsultDialog>
      <div class="clearfix"></div>
    </el-dialog>
  </div>
</template>
<script>
import caseDropMenuVue from "@/views/productCase/caseDropMenu.vue";
import operationConsultDialog from "@/views/operationConsult/index.vue";
export default {
  props: { nowActive: { type: String } },
  components: { caseDropMenuVue, operationConsultDialog },
  data() {
    return {
      showHover: null,
      showPopover: false,
      navList: [
        { label: "首页", name: "Index", url: "/" },
        { label: "关于云翎", name: "About", url: "/about" },
        { label: "产品案例", name: "ProductCase", dropMenu: true },
        { label: "加入我们", name: "Join", url: "/joinUs" },
        { label: "业务咨询", name: "Information", dialog: true },
      ],
      dialogVisible: false,
    };
  },
  created() {},
  mounted() {},
  methods: {
    navClickHandler(row) {
      //导航页跳转
      if (row.url) {
        this.$router.push(row.url).catch((err) => err);
      }
      if (row.dialog) {
        this.dialogVisible = true;
      }
    },
    // 案例菜单
    handlerClicker(e) {
      if (e) {
        this.showPopover = false;
      }
    },
    // 关闭业务咨询弹框
    closeDialogHandler(e) {
      this.dialogVisible = false;
    },
  },
};
</script>
<style scoped lang="scss">
.page_head_box {
  float: left;
  width: 100%;
  background: rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(13.591408729553223px);
  height: 78px;
  position: relative;
  z-index: 999;
  .page_con_center {
    display: flex;
    align-items: center;
    height: 100%;
  }
  .logo_box {
    float: left;
    width: 305px;
    .logo {
      width: 157px;
      height: auto;
    }
  }
  .nav_box {
    float: left;
    width: calc(100% - 305px);
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .nav_item {
      float: left;
      height: 100%;
      // color: #9ba1b2;
      color: rgba(255, 255, 255, 0.6);
      font-size: 16px;
      position: relative;
      display: flex;
      align-items: center;
      cursor: pointer;
      span {
        float: left;
        width: 100%;
        height: 100%;
        @include flexBoxCenter(center, center);
        ::v-deep .el-popover__reference-wrapper {
          height: 100%;
          width: 100%;
          display: block;
        }
      }
      &.this,
      &:focus,
      &:visited {
        color: #fff;
        &::after {
          content: "";
          float: left;
          position: absolute;
          width: 100%;
          height: 2px;
          border-radius: 1px;
          background: #0ff;
          bottom: 0;
          left: 0;
        }
      }
      &:hover {
        color: #fff;
      }
    }
  }
}
</style>
